export const GENERIC_ERROR_HAS_OCCURRED = 'GENERIC_ERROR_HAS_OCCURRED';
export const SET_WEB_RELAUNCH_STYLE_ENABLED = 'SET_WEB_RELAUNCH_STYLE_ENABLED';
export const SET_CALCULATION = 'SET_CALCULATION';
export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';
export const SET_LANGUAGE_CHOOSER_DISABLED = 'SET_LANGUAGE_CHOOSER_DISABLED';

export const CYBERSOURCE_INIT_SUCCEEDED = 'CYBERSOURCE_INIT_SUCCEEDED';
export const CYBERSOURCE_CARDINAL_INIT_SUCCEEDED = 'CYBERSOURCE_CARDINAL_INIT_SUCCEEDED';

export const CYBERSOURCE_SET_SUBMITTING = 'CYBERSOURCE_SET_SUBMITTING';

// Optile
export const OPTILE_INIT_SUCCEEDED = 'OPTILE_INIT_SUCCEEDED';

export const OPTILE_SUBMITTING_SUCCEEDED = 'OPTILE_SUBMITTING_SUCCEEDED';
export const OPTILE_SUBMITTING_LOADING = 'OPTILE_SUBMITTING_LOADING';
export const OPTILE_SUBMITTING_ERROR = 'OPTILE_SUBMITTING_ERROR';

export const OPTILE_PAYMENT_AUTORISE = 'OPTILE_PAYMENT_AUTORISE';

export const LOAD_CARDS_SUCCEEDED = 'LOAD_CARD_SUCCEEDED';
export const REMOVE_CREDIT_CARD_SUCCEEDED = 'REMOVE_CREDIT_CARD_SUCCEEDED';
